<template>
	<section class="section cms">
		<div class="container">
			<E404 v-if="error404" />
			<section v-else>
				<Loading :active.sync="loading"></Loading>

				<div v-for="item in contents" class="cms cms-page" v-bind:key="item.id">
					<h1 v-html="item.title" class="title"></h1>
					<div v-html="item.body" class="body"></div>
				</div>
			</section>
		</div>
	</section>
</template>

<script>
import E404 from '@/components/common/E404'

import Loading from 'vue-loading-overlay'

export default {
	name: 'Cms',
	components: {
		Loading,
		E404,
	},
	data() {
		return {
			//_this: this,
			loading: true,
			contents: [],
			path: null,
			error404: false,
		}
	},
	mounted() {
		var _this = this
		console.log(_this.$route)
		this.$http
			.get('/cmspath', { params: { path: _this.$route.fullPath } })
			.then((response) => {
				console.log('CMSPATH:', response)
				if (response.data.cms !== undefined) {
					_this.contents = response.data.cms
				} else {
					_this.error404 = true
				}
				_this.loading = false
			})
			.catch(() => {
				_this.loading = false
				_this.error404 = true
			})
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
